<template>
  <div>
    <checkmark-list v-if="specialNeedsRecipientAgeGroups" :tips="specialNeedsAgeDisplay" />
    <tag-label-group
      v-if="specialNeedsCareExperience"
      :items="specialNeedsCareDisplay"
      title="Types of special needs experience"
      class="mt-16"
    />
    <tag-label-group
      v-if="specialNeedsConditionExperience"
      :items="specialNeedsConditionDisplay"
      title="Special needs conditions experience"
      class="mt-16"
    />
    <tag-label-group
      v-if="specialNeedsServiceExperience"
      :items="specialNeedsServiceDisplay"
      title="Special needs services experience"
      class="mt-16"
    />
  </div>
</template>

<script lang="ts">
import { experienceMap, ExperienceDisplay } from '../../__types__/ExperienceTypes';
import CheckmarkList from '@/components/checkmark_list/CheckmarkList.vue';
import TagLabelGroup from '@/components/tag_label_group/TagLabelGroup.vue';

export default {
  name: 'ProfileSpecialNeedsExperience',
  components: { TagLabelGroup, CheckmarkList },
  props: {
    specialNeedsRecipientAgeGroups: {
      type: Array as () => string[],
      default: () => [],
    },
    specialNeedsCareExperience: {
      type: Array as () => string[],
      default: () => [],
    },
    specialNeedsConditionExperience: {
      type: Array as () => string[],
      default: () => [],
    },
    specialNeedsServiceExperience: {
      type: Array as () => string[],
      default: () => [],
    },
  },
  computed: {
    specialNeedsAgeDisplay(): ExperienceDisplay[] {
      return this.mapExperienceKeys(this.specialNeedsRecipientAgeGroups, 'specialNeedsAges');
    },
    specialNeedsCareDisplay(): ExperienceDisplay[] {
      return this.mapExperienceKeys(this.specialNeedsCareExperience, 'specialNeedsCare');
    },
    specialNeedsConditionDisplay(): ExperienceDisplay[] {
      return this.mapExperienceKeys(this.specialNeedsConditionExperience, 'specialNeedsConditions');
    },
    specialNeedsServiceDisplay(): ExperienceDisplay[] {
      return this.mapExperienceKeys(this.specialNeedsServiceExperience, 'specialNeedsServices');
    },
  },
  methods: {
    mapExperienceKeys(keys: string[], mapType: keyof typeof experienceMap): ExperienceDisplay[] {
      return keys.map((key) => experienceMap[mapType]?.[key]);
    },
  },
};
</script>
